import { Fragment } from "react";
import SectionHeader from "./SectionHeader";
import LoadingState from "./LoadingState";
import EmptyState from "./EmptyState";
import SearchResultsTable from "./SearchResultsTable";

interface ColumnDefinition {
  key: string;
  label: string;
  accessor: (row: any) => any;
  highlight?: boolean;
  formatter?: (value: any) => string;
}

interface SearchSectionProps {
  title: string;
  count: number;
  isLoading: boolean;
  data: any[];
  columns: ColumnDefinition[];
  displayQuery: string;
  searchQuery: string;
  onViewMore: () => void;
  onRowClick: (row: any) => void;
  highlightMatchingText: (text: string, query: string) => JSX.Element;
  showBorder?: boolean;
  footer?: JSX.Element;
}

function SearchSection({
  title,
  count,
  isLoading,
  data,
  columns,
  displayQuery,
  searchQuery,
  onViewMore,
  onRowClick,
  highlightMatchingText,
  showBorder = false,
  footer,
}: Readonly<SearchSectionProps>): JSX.Element {
  const content = (
    <>
      <SectionHeader title={title} count={count} onViewMore={onViewMore} />
      {isLoading ? (
        <LoadingState />
      ) : data.length === 0 ? (
        <EmptyState displayQuery={displayQuery} />
      ) : (
        <Fragment>
          <SearchResultsTable
            columns={columns}
            data={data}
            onRowClick={onRowClick}
            searchQuery={searchQuery}
            highlightMatchingText={highlightMatchingText}
          />
          {footer}
        </Fragment>
      )}
    </>
  );

  if (showBorder) {
    return <div className="border-b border-dropDownBorder">{content}</div>;
  }

  return <div>{content}</div>;
}

export default SearchSection;

